import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { trackClick } from '../utils/analytics';

const { FiHome, FiClock, FiHeart, FiGrid } = FiIcons;

const BottomTabs = ({ activeTab, onTabChange, bookmarkCount = 0 }) => {
  const tabs = [
    { id: 'home', label: 'Home', icon: FiHome },
    { id: 'history', label: 'History', icon: FiClock },
    { id: 'bookmarks', label: 'Saved', icon: FiHeart, badge: bookmarkCount },
    { id: 'categories', label: 'Explore', icon: FiGrid },
  ];

  const handleTabClick = (tabId) => {
    trackClick(`Tab: ${tabId}`, 'Navigation');
    onTabChange(tabId);
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 px-4 pb-6 pointer-events-none">
      <div className="max-w-md mx-auto bg-slate-950/95 backdrop-blur-xl rounded-[2.5rem] p-2 flex items-center justify-between shadow-2xl shadow-indigo-200/50 pointer-events-auto border border-white/10">
        {tabs.map((tab) => {
          const isActive = activeTab === tab.id;
          return (
            <button 
              key={tab.id} 
              onClick={() => handleTabClick(tab.id)} 
              className={`relative flex-1 flex flex-col items-center justify-center py-3 rounded-[2rem] transition-all duration-300 ${isActive ? 'bg-white shadow-lg' : 'text-slate-400 hover:text-white'}`}
            >
              <div className="relative">
                <SafeIcon icon={tab.icon} className={`text-lg mb-1 transition-transform ${isActive ? 'text-indigo-600 scale-110' : ''}`} />
                {tab.badge > 0 && !isActive && (
                  <span className="absolute -top-1 -right-1 w-4 h-4 bg-indigo-600 text-white text-[8px] font-black flex items-center justify-center rounded-full border-2 border-slate-950">
                    {tab.badge}
                  </span>
                )}
              </div>
              <span className={`text-[10px] font-black uppercase tracking-widest ${isActive ? 'text-slate-950' : 'text-inherit'}`}>
                {tab.label}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default BottomTabs;